<script setup lang="ts">
import dayjs from "dayjs";

const today = dayjs();
const route = useRoute();

const { blog_id, blog_num } = route.params;

//　プレビュー用
const mode = computed(() => route.query.mode ?? "");

const { data } = await useFetch(
  `/api/blog/${blog_id}/detail/${blog_num}?mode=${mode.value}`,
);

// 最終更新から5年以上経過した記事を古い記事として表示
const base = today.subtract(5, "year");
const isOld = computed(() => {
  if (data.value) {
    // 更新日があれば更新日を優先
    const target_date = dayjs(
      data.value.updated_at || data.value.pub_date.split("（")[0],
    );
    if (target_date.isBefore(base)) return true;
  }
  return false;
});

if (data.value && !data.value.blog_title) {
  throw createError({ statusCode: 404, message: "Not Found", fatal: true });
}

// srcを取り出す
let body = data.value?.blog_body || "";
// img src=""の正規表現
const m = body.matchAll(/<img src="(.+?)"/gm);
// background url()のURL抜き出す正規表現
const m2 = body.matchAll(/url\((.+?)\)/gm);

// 画像のsrcのみを取り出し、空を排除し、重複を排除する
const imageSrcs = Array.from(
  new Set([...m, ...m2].map((v) => v[1] || "").filter((v) => v)),
);

// 画像のproxyをはさみ表示する(CORS対策)
const $img = useImage();
imageSrcs.forEach((src) => {
  // 置き換えするURLとして
  let _src = src;

  //　先頭が//の場合
  if (src.match(/^\/\//)) {
    _src = "https:" + src;
  }
  // 先頭が/BLOGの場合
  if (src.match(/^\/BLOG/)) {
    _src = "https://static.famitei.co.jp" + src;
  }
  //#TODO 他にも画像パスの例外があればここで対応する

  // s3画像のときはimgproxyを使わない
  if (!src.match(/^https:\/\/s3-ap-northeast-1.amazonaws.com/)) {
    _src = $img(_src, {}, { provider: "customimgproxy" });
  }

  body = body.replace(src, _src);
});

useHead({
  title: data.value?.blog_title,
});

useBreadcrumbs([
  { name: "TOP", path: "/" },
  { name: data.value?.blog_name || "", path: `/BLOG/${blog_id}` },
  {
    name: data.value?.blog_title || "",
    path: `/BLOG/${blog_id}/blog.php/${blog_num}`,
  },
]);
</script>

<template>
  <div v-if="data" class="p-blog__detail wrapper">
    <p
      v-if="mode == 'preview'"
      class="text-red-500 text-2xl border p-5 border-red-500"
    >
      このURLはプレビュー中です。リンク設定しないようご注意ください。
    </p>
    <div class="p-blog__label--old" v-if="isOld">
      <p>{{ data.pub_date }}に書かれた記事です。</p>
      <p>記事の内容が古くなっている場合がございます。</p>
    </div>
    <h1 class="text-3xl text-center font-bold border-b mt-8 mb-4">
      {{ data.blog_title }}
    </h1>
    <div class="p-blog__detail">
      <div class="p-blog__content">
        <div class="blog__content p-staticpage" v-html="body"></div>
      </div>
    </div>
  </div>
</template>
